import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
window.jQuery = window.$ = require("jquery");
import Glide, { Controls, Breakpoints } from "@glidejs/glide/dist/glide.modular.esm"; // new Glide('.glide').mount({ Controls, Breakpoints })

import "magnific-popup";
import { initSidebar } from "./modules/sidebar";

require("readmore-js"); // import 'waypoints/lib/jquery.waypoints.js';


require("waypoints/lib/jquery.waypoints.js");

function library(module) {
  $(function () {
    if (module.init) {
      module.init();
    }
  });
  return module;
}

var APP = library(function () {
  var currentScroll = $(window).scrollTop();
  var windowWidth = $(window).width();

  function disableScroll() {
    $("html, body").css({
      overflow: "hidden",
      height: "100%"
    });
  }

  function enableScroll() {
    $("html, body").css({
      overflowX: "hidden",
      overflowY: "auto",
      height: "auto"
    });
    $(window).scrollTop(currentScroll);
  }

  function isExist(arrayOfElements) {
    var elementIsExist = true;
    arrayOfElements.forEach(function (element) {
      if (element !== undefined && element !== null) {
        if (element.length === 0) {
          elementIsExist = false;
        }
      } else {
        elementIsExist = false;
      }
    });
    return elementIsExist;
  }

  function cookies() {
    var cookie = $(".cookies");
    var button = $(".cookies button");

    if (isExist([cookie, button])) {
      if (!localStorage.getItem("cookieWasDisplayed")) {
        cookie.slideDown();
      }

      button.on("click", function () {
        cookie.slideUp();
        localStorage.setItem("cookieWasDisplayed", true);
      });
    }
  }

  function readmore() {
    if ($(".readmore").length) {
      $(".readmore").readmore({
        speed: 75,
        collapsedHeight: 100,
        moreLink: '<a class="more" href="#">' + readmore_text + "</a>",
        lessLink: '<a class="more less" href="#">' + readless_text + "</a>"
      });
    }
  }

  function initTestimonials() {
    if ($(".testimonials").length) {
      var glide = new Glide("#testimonials", {
        perView: 2,
        autoheight: true,
        breakpoints: {
          768: {
            perView: 1
          }
        }
      });
      glide.mount({
        Controls: Controls,
        Breakpoints: Breakpoints
      });
    }
  }

  function privatePopup() {
    var privatePopup = document.querySelector(".private-popup");
    if (!privatePopup) return;
    var acceptBtn = privatePopup.querySelector(".accept-btn");
    var bodyEl = document.querySelector("body");
    acceptBtn.addEventListener("click", function () {
      bodyEl.classList.add("is-accepted");
      privatePopup.classList.add("is-disabled");
    });
  }

  function menu() {
    var nav = $(".page-header__nav");
    var openTrigger = $(".page-header__hamburger");
    var closeTrigger = $(".page-header__close");

    if (isExist([nav, openTrigger, closeTrigger]) && windowWidth < 1200) {
      nav.css({
        display: "flex"
      }).hide();
      openTrigger.on("click", function () {
        nav.slideDown();
        disableScroll();
      });
      closeTrigger.on("click", function () {
        nav.slideUp();
        enableScroll();
      });
    }
  }

  function chnageBackgroundOnMobile() {
    var mobileBgElement = $("[data-mobile-img]");
    var mobileBgArray = Array.prototype.slice.call(mobileBgElement);
    mobileBgArray.forEach(function (element) {
      var dateMobileImg = $(element).attr("data-mobile-img");
      var dateDesktopImg = $(element).attr("data-desktop-img");

      if (windowWidth < 992) {
        if (dateMobileImg === "transparent") {
          $(element).css({
            background: dateMobileImg
          });
        } else {
          $(element).css({
            "background-image": "url(" + dateMobileImg + ")"
          });
        }
      } else {
        if (dateDesktopImg === "transparent") {
          $(element).css({
            background: dateDesktopImg
          });
        } else {
          $(element).css({
            "background-image": "url(" + dateDesktopImg + ")"
          });
        }
      }
    });
  }

  function newsletter() {
    var wpcf7Elm = document.querySelector(".home-newsletter .wpcf7");

    if (wpcf7Elm) {
      wpcf7Elm.addEventListener("wpcf7submit", function (event) {
        $("#formContainer").hide();
        $("#thankyoumessage").fadeIn();
      }, false);
    }

    var emailIsValid = function emailIsValid(email) {
      var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(email);
    };

    var form = document.querySelector(".home-newsletter form");

    if (isExist([form])) {
      var input = form.querySelector("#newsletter");
      var label = form.querySelector("label");
      var submitButton = document.querySelector("#fake-submit");
      var oryginalSubmitButton = form.querySelector(".button-hidden");
      var newsletterPopup = $(".newsletter-popup");
      newsletterPopup.css({
        display: "flex"
      }).hide();
      newsletterPopup.find(".btn-main--disable").on("click", function (e) {
        e.preventDefault();
        newsletterPopup.fadeOut();
      });
      newsletterPopup.find(".btn-main[type=submit]").on("click", function (e) {
        e.preventDefault();
        var checkboxes = Array.prototype.slice.call(document.querySelectorAll(".newsletter-popup input"));
        var isValid = true;
        checkboxes.forEach(function (element) {
          if (!element.checked) {
            element.classList.add("invalid");
            isValid = false;
          } else {
            element.classList.remove("invalid");
          }
        });

        if (isValid) {
          newsletterPopup.fadeOut();
          oryginalSubmitButton.click();
        }
      });

      if (submitButton) {
        submitButton.addEventListener("click", function (event) {
          event.preventDefault();
          var value = input.value;

          if (emailIsValid(value)) {
            newsletterPopup.fadeIn();
          } else {
            input.classList.add("invalid");
          }
        });
      }

      input.addEventListener("focus", function (e) {
        input.classList.remove("invalid");

        if (label) {
          label.classList.remove("invalid");
          $(label).css("display", "none");
        }
      });
      input.addEventListener("blur", function (e) {
        if (!emailIsValid(e.target.value)) {
          if (!input.value.length > 0) {
            $(label).css("display", "block");
          }
        }
      });
      input.addEventListener("change", function (e) {
        input.classList.remove("invalid");

        if (label) {
          label.classList.remove("invalid");
        }
      });
    }
  }

  function moviePlay() {
    $(".movie-section__play").on("click", function () {
      var currentMovie = $(this).parents(".movie-section");
      var iframe = currentMovie.find(".movie-section__iframe");
      currentMovie.find(".movie-section__bg").hide();
      iframe.fadeIn(1000, function () {
        var src = $(this).attr("data-src");
        $(this).attr("src", src + "?autoplay=1&rel=0");
      });
    });
  }

  var FormValidation = /*#__PURE__*/function () {
    function FormValidation(form) {
      _classCallCheck(this, FormValidation);

      this.form = form;
      this.inputs = Array.prototype.slice.call(this.form.querySelectorAll(".wpcf7-validates-as-required"));
      this.submitButton = form.querySelector("button");
      this.addInputsEvent();
      this.checkInputValues();
      this.onSubmit();
    }

    _createClass(FormValidation, [{
      key: "inputsValidation",
      value: function inputsValidation(input) {
        var inputType = input.getAttribute("type");
        var label = input.parentNode.querySelector("label");

        switch (inputType) {
          case "checkbox":
            if (!input.checked) {
              input.classList.add("invalid");

              if (label) {
                label.classList.add("invalid");
              }

              return false;
            }

            break;

          case "hidden":
            if (input.value === "") {
              input.classList.add("invalid");

              if (label) {
                label.classList.add("invalid");
              }

              return false;
            }

            break;

          case "text":
            if (input.value === "") {
              input.classList.add("invalid");

              if (label) {
                label.classList.add("invalid");
              }

              return false;
            }

            break;

          case "email":
            if (!this.emailIsValid(input.value)) {
              input.classList.add("invalid");

              if (label) {
                label.classList.add("invalid");
              }

              return false;
            }

            break;

          default:
            console.log("Please add validation rules to", inputType);
        }

        return true;
      }
    }, {
      key: "addInputsEvent",
      value: function addInputsEvent() {
        var _this = this;

        this.inputs.forEach(function (input) {
          var inputType = input.getAttribute("type");
          var label = input.parentNode.parentNode.querySelector("label");

          if (label) {
            label.addEventListener("click", function () {
              input.focus();
            });
          }

          input.addEventListener("focus", function (e) {
            input.classList.remove("invalid");

            if (label) {
              label.classList.remove("invalid");
              $(label).css("display", "none");
            }
          });
          input.addEventListener("blur", function (e) {
            if (!_this.inputsValidation(input)) {
              if (!input.value.length > 0) {
                $(label).css("display", "block");
              }
            }
          });
          input.addEventListener("change", function (e) {
            input.classList.remove("invalid");

            if (label) {
              label.classList.remove("invalid");
            }
          });
        });
      }
    }, {
      key: "checkInputValues",
      value: function checkInputValues() {
        this.inputs.forEach(function (input) {
          var inputType = input.getAttribute("type");
          var label = input.parentNode.querySelector("label");

          if (input.value && (inputType === "text" || inputType === "email")) {
            input.classList.remove("invalid");

            if (label) {
              label.classList.remove("invalid");
              $(label).css("display", "none");
            }
          }
        });
      }
    }, {
      key: "emailIsValid",
      value: function emailIsValid(email) {
        var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRegex.test(email);
      }
    }, {
      key: "onSubmit",
      value: function onSubmit() {
        var _this2 = this;

        this.submitButton.addEventListener("click", function (event) {
          event.preventDefault();
          var isValid = [];

          _this2.inputs.forEach(function (input) {
            if (!_this2.inputsValidation(input)) {
              isValid.push(_this2.inputsValidation(input));
            }
          });

          if (isValid.length === 0) {
            _this2.form.submit();
          }
        });
      }
    }]);

    return FormValidation;
  }();

  function formValidation() {
    var contactForm = document.querySelector(".contact-form .wpcf7-form");

    if (isExist([contactForm])) {
      new FormValidation(contactForm);
    }
  }

  function initPopup() {
    if ($(".gallery").length > 1) {
      $(".gallery").magnificPopup({
        type: "image",
        gallery: {
          enabled: true
        }
      });
    }
  }

  function menuSticky() {
    var pageHeader = $(".page-header");
    var stickyClass = "page-header--stick";
    var sidebar = document.querySelector(".sidebar"); // const NavY = pageHeader.offset().top;

    var NavY = 0;

    var stickyNav = function stickyNav() {
      var ScrollY = $(window).scrollTop();

      if (ScrollY > NavY) {
        pageHeader.addClass(stickyClass);
        if (sidebar) sidebar.classList.add("is-active");
      } else {
        pageHeader.removeClass(stickyClass);
        if (sidebar) sidebar.classList.remove("is-active");
      }
    };

    stickyNav();
    $(window).scroll(function () {
      stickyNav();
    });
  }

  function animate() {
    var animateName = "animated fadeInUp";
    var animateText = $(".animate-text");
    var articleBanner = $(".article-banner");

    if (animateText.length) {
      animateText.find("p, h1 ,h2 ,h3 ,h4 ,ul ,ol, span, .btn").addClass("animate");
    }

    var offset = "85%";
    var animateElements = [].slice.call(document.querySelectorAll(".animate"));

    if (animateElements.length) {
      animateElements.forEach(function (item) {
        var animateWaypoint = new Waypoint({
          element: $(item),
          handler: function handler() {
            $(item).addClass(animateName);
          },
          offset: offset
        });
      });
    }
  }

  function homeBoxHover() {
    $(".home-box__left--bg-hover").mouseenter(function () {
      $(this).addClass("hover");
    });
    $(".home-box__left--bg-hover").parent().mouseleave(function () {
      $(this).find(".home-box__left--bg-hover").removeClass("hover");
    });
    $(".home-box__left--bg-hover").next(".home-box__right").mouseenter(function () {
      $(this).prev(".home-box__left--bg-hover").removeClass("hover");
    });
  }

  function articleLoadNews() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    $(".article-waypoint" + id).each(function () {
      var waypoint = new Waypoint({
        element: $(this),
        handler: function handler(direction) {
          // To do - add ajax wp call
          if (direction === "down") {
            if (loadNewsIds[loadNewsIndex]) {
              jQuery.ajax({
                type: "post",
                // dataType : "json",
                url: ajax_url,
                data: {
                  action: "get_blog_posts",
                  post_id: loadNewsIds[loadNewsIndex]
                },
                success: function success(response) {
                  $(".article-waypoint-area").append($(response));
                  animate();
                  articleLoadNews("-" + loadNewsIds[loadNewsIndex]);
                  articleState();
                  loadNewsIndex++;
                  initPopup();
                  moviePlay();
                }
              });
            }
          }
        },
        offset: "bottom-in-view"
      });
    });
  }

  function articleState() {
    $(".state-waypoint-top").each(function () {
      var waypoint = new Waypoint({
        element: $(this),
        handler: function handler(direction) {
          if (direction === "down") {
            window.history.replaceState("state", "", $(this.element).attr("data-state-url"));
          }
        },
        offset: "bottom-in-view"
      });
    });
    $(".state-waypoint-btm").each(function () {
      var waypoint = new Waypoint({
        element: $(this),
        handler: function handler(direction) {
          if (direction === "up") {
            window.history.replaceState("state", $(this.element).attr("data-state-title"), $(this.element).attr("data-state-url"));
          }
        },
        offset: "bottom-in-view"
      });
    });
  }

  function menuScroll() {
    var moveToSection = function moveToSection() {
      var pathName = window.location.pathname;
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var scrollParam = urlParams.get("sc");
      var lastElement = pathName.split("/").pop(); //let lastElement = pathName.substr(pathName.lastIndexOf('/') + 1);

      if (scrollParam != null) {
        lastElement = scrollParam;
        window.history.pushState("", "", scrollParam);
      }

      if (HOME_SECTIONS.indexOf(lastElement) !== -1) {
        var $section = $(".section-" + lastElement);

        if ($section.length) {
          $("html,body").animate({
            scrollTop: $section.offset().top - 50
          });
        }
      } else {// window.location.href =pathName
      }
    };

    moveToSection();
    $(".page-header .homepage-menu-item").on("click", function (event) {
      event.preventDefault();
      $(".page-header__close").trigger("click");
      window.history.pushState("", "", $(this).attr("href"));
      moveToSection();
    });
  }

  function init() {
    privatePopup();
    cookies();
    menu();
    readmore();
    chnageBackgroundOnMobile();
    newsletter();
    moviePlay();
    formValidation();
    initPopup();
    menuSticky();
    animate();
    homeBoxHover();
    articleLoadNews();
    articleState();
    initTestimonials();
    menuScroll();
    initSidebar();
  }

  return {
    init: init
  };
}());

function ZoomControl(controlDiv, map) {
  controlDiv.style.padding = "5px";
  var controlWrapper = document.createElement("div");
  controlWrapper.classList.add("map-controlls");
  controlDiv.appendChild(controlWrapper);
  var zoomInImage = document.createElement("img");
  zoomInImage.src = mapPlusUrl;
  var zoomInButton = document.createElement("div");
  zoomInButton.classList.add("map-controlls__zoomIn");
  zoomInButton.appendChild(zoomInImage);
  controlWrapper.appendChild(zoomInButton);
  var zoomOutImage = document.createElement("img");
  zoomOutImage.src = mapMinusUrl;
  var zoomOutButton = document.createElement("div");
  zoomOutButton.classList.add("map-controlls__zoomOut");
  zoomOutButton.appendChild(zoomOutImage);
  controlWrapper.appendChild(zoomOutButton); // Setup the click event listener - zoomIn

  google.maps.event.addDomListener(zoomInButton, "click", function () {
    map.setZoom(map.getZoom() + 1);
  }); // Setup the click event listener - zoomOut

  google.maps.event.addDomListener(zoomOutButton, "click", function () {
    map.setZoom(map.getZoom() - 1);
  });
}

function initMap() {
  var mapContainer = document.getElementById("contact-map__map");

  if (mapContainer) {
    var latlng = new google.maps.LatLng(52.070521, 21.036699);
    var mapOptions = {
      center: latlng,
      zoom: 16,
      disableDefaultUI: true,
      styles: [{
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
          saturation: 36
        }, {
          color: "#333333"
        }, {
          lightness: 40
        }]
      }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
          visibility: "on"
        }, {
          color: "#ffffff"
        }, {
          lightness: 16
        }]
      }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
          visibility: "off"
        }]
      }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
          color: "#fefefe"
        }, {
          lightness: 20
        }]
      }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
          color: "#fefefe"
        }, {
          lightness: 17
        }, {
          weight: 1.2
        }]
      }, {
        featureType: "administrative.land_parcel",
        elementType: "geometry.fill",
        stylers: [{
          visibility: "on"
        }]
      }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
          color: "#f5f5f5"
        }, {
          lightness: 20
        }]
      }, {
        featureType: "landscape",
        elementType: "labels.text.fill",
        stylers: [{
          hue: "#ff3e00"
        }, {
          visibility: "on"
        }]
      }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
          color: "#f5f5f5"
        }, {
          lightness: 21
        }]
      }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
          color: "#dedede"
        }, {
          lightness: 21
        }]
      }, {
        featureType: "poi.park",
        elementType: "geometry.fill",
        stylers: [{
          color: "#eef1e9"
        }]
      }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
          color: "#ffffff"
        }, {
          lightness: 17
        }]
      }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
          color: "#ffffff"
        }, {
          lightness: 29
        }, {
          weight: "0.10"
        }]
      }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
          color: "#ffffff"
        }, {
          lightness: 18
        }]
      }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
          weight: "0.70"
        }]
      }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
          color: "#ffffff"
        }, {
          lightness: 16
        }, {
          weight: "0.70"
        }]
      }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
          color: "#f2f2f2"
        }, {
          lightness: 19
        }]
      }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
          color: "#e9e9e9"
        }, {
          lightness: 17
        }]
      }, {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [{
          color: "#bcd9e4"
        }]
      }, {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{
          hue: "#ff0000"
        }, {
          visibility: "on"
        }]
      }]
    };
    var map = new google.maps.Map(mapContainer, mapOptions);
    var zoomControlDiv = document.createElement("div");
    var zoomControl = new ZoomControl(zoomControlDiv, map);
    zoomControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(zoomControlDiv);
    var iconBase = {
      url: pinUrl,
      scaledSize: new google.maps.Size(25, 25)
    };
    var marker = new google.maps.Marker({
      position: latlng,
      icon: iconBase,
      map: map
    });
  }
}

window.initMap = initMap;